import React from 'react';

const IcTokenDonate = () => {
  return (
    <svg
      width="106"
      height="106"
      viewBox="0 0 106 106"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M72.9229 52.7956C80.9 52.7956 87.3667 46.329 87.3667 38.3519C87.3667 30.3749 80.9 23.9082 72.9229 23.9082C64.9459 23.9082 58.4792 30.3749 58.4792 38.3519C58.4792 46.329 64.9459 52.7956 72.9229 52.7956Z"
        fill="#997600"
      />
      <path
        d="M72.9229 52.2018C69.1437 52.2017 65.5151 50.7204 62.8155 48.0757C60.116 45.4309 58.5606 41.8334 58.483 38.055C58.481 38.1538 58.4792 38.2526 58.4792 38.3519C58.4836 42.1798 60.0072 45.8494 62.7155 48.5546C65.4237 51.2597 69.0951 52.7792 72.9229 52.7792C76.7508 52.7792 80.4222 51.2597 83.1304 48.5546C85.8387 45.8494 87.3623 42.1798 87.3667 38.3519C87.3667 38.2526 87.3649 38.1538 87.3629 38.055C87.2853 41.8334 85.7299 45.4309 83.0304 48.0757C80.3308 50.7204 76.7022 52.2017 72.9229 52.2018Z"
        fill="#FFCC21"
      />
      <path
        d="M72.9229 51.608C80.2441 51.608 86.1791 45.673 86.1791 38.3519C86.1791 31.0308 80.2441 25.0958 72.9229 25.0958C65.6018 25.0958 59.6669 31.0308 59.6669 38.3519C59.6669 45.673 65.6018 51.608 72.9229 51.608Z"
        fill="#FFCC21"
      />
      <path
        d="M72.923 25.7013C76.3862 25.7013 79.7119 27.0567 82.1886 29.4775C84.6653 31.8983 86.0962 35.1923 86.1752 38.6546C86.1775 38.554 86.1791 38.4531 86.1791 38.3519C86.1797 36.6107 85.8374 34.8863 85.1715 33.2774C84.5056 31.6685 83.5293 30.2065 82.2983 28.975C81.0673 27.7435 79.6057 26.7666 77.9971 26.1001C76.3884 25.4336 74.6642 25.0906 72.923 25.0906C71.1817 25.0906 69.4575 25.4336 67.8489 26.1001C66.2402 26.7666 64.7786 27.7435 63.5476 28.975C62.3166 30.2065 61.3403 31.6685 60.6744 33.2774C60.0085 34.8863 59.6662 36.6107 59.6669 38.3519C59.6669 38.4531 59.6684 38.554 59.6707 38.6546C59.7497 35.1923 61.1806 31.8983 63.6573 29.4775C66.134 27.0567 69.4597 25.7013 72.923 25.7013Z"
        fill="#FCDF81"
      />
      <path
        d="M81.6846 40.5796C81.1941 42.5063 80.0821 44.2176 78.5209 45.4486C76.9596 46.6797 75.0361 47.3617 73.0481 47.3893C71.0601 47.4168 69.1185 46.7883 67.5237 45.6011C65.9289 44.4138 64.77 42.734 64.2262 40.8216"
        stroke="#997600"
        stroke-width="1.09449"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M64.2263 35.8821C64.7639 33.9914 65.9031 32.3275 67.4712 31.1422C69.0393 29.957 70.9509 29.3151 72.9165 29.3137C74.8822 29.3123 76.7947 29.9515 78.3645 31.1345C79.9343 32.3175 81.0758 33.9798 81.6161 35.8698"
        stroke="#997600"
        stroke-width="1.09449"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M36.727 50.5132V72.1943C36.727 72.1943 41.4304 77.4712 52.2136 77.4712H71.9317C72.8661 77.4722 73.788 77.2577 74.626 76.8445C77.1646 75.5908 82.9525 72.5643 87.89 68.7529C92.0903 65.5106 96.2906 61.4162 98.7577 58.9023C100.676 56.948 101.417 54.0575 100.467 51.4896C99.4154 48.6508 95.2118 44.0361 87.5004 49.5807C73.6198 59.5609 72.7565 58.8461 70.6502 59.4735C68.3407 60.008 61.1956 59.6069 59.7043 59.1934C58.274 58.7968 52.0714 57.1203 69.2946 56.4257C71.0078 56.3772 72.643 55.6993 73.8881 54.5215C78.8056 49.737 72.1863 46.6794 67.8617 46.4749C63.0097 46.2455 38.333 43.9744 36.727 50.5132Z"
        fill="#FFE8BB"
      />
      <path
        d="M36.7606 45.5133H22.2678C17.7201 45.5133 13.3586 47.3199 10.1429 50.5357C6.92714 53.7514 5.12056 58.1129 5.12056 62.6606C5.12056 64.9124 5.56408 67.1422 6.42581 69.2226C7.28755 71.303 8.55061 73.1933 10.1429 74.7856C13.3586 78.0013 17.7201 79.8079 22.2678 79.8079H47.7837L36.7606 45.5133Z"
        fill="url(#paint0_linear_1_2)"
      />
      <path
        d="M49.349 81.0089L39.2249 82.0785C38.8993 82.1129 38.5702 82.0792 38.2583 81.9796C37.9465 81.8799 37.6588 81.7165 37.4135 81.4997C37.1682 81.2829 36.9707 81.0174 36.8335 80.7202C36.6963 80.423 36.6224 80.1004 36.6166 79.7731L35.9823 44.2812C35.9751 43.8781 36.0509 43.4778 36.2049 43.1051C36.359 42.7325 36.5881 42.3956 36.878 42.1153C37.1678 41.835 37.5122 41.6173 37.8897 41.4757C38.2673 41.3342 38.6699 41.2718 39.0726 41.2925L46.3012 41.6634C47.1965 41.7094 48.0455 42.0752 48.6938 42.6943C49.342 43.3135 49.7465 44.1448 49.8335 45.037L52.9163 76.6347C53.019 77.6869 52.7016 78.7371 52.0335 79.5564C51.3653 80.3757 50.4004 80.8978 49.349 81.0089Z"
        fill="#314356"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1_2"
          x1="5.12056"
          y1="62.6606"
          x2="47.7837"
          y2="62.6606"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0F5EDB" />
          <stop offset="0.98976" stop-color="#010C1C" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default IcTokenDonate;
